// Generated by purs version 0.13.0
"use strict";
var Data_Functor = require("../Data.Functor/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var keys = (function () {
    var $0 = Data_Functor["void"](Data_Map_Internal.functorMap);
    return function ($1) {
        return $0($1);
    };
})();
module.exports = {
    keys: keys
};
